import IconNext from "./IconNext.vue";
export default IconNext